// https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories
export const messageTemplateKeys = {
    all: (workspaceId: number) => ["MessageTemplates", workspaceId] as const,
    detail: ({
        workspaceId,
        templateId,
    }: {
        workspaceId: number;
        templateId: number;
    }) => [...messageTemplateKeys.all(workspaceId), templateId] as const,
};
